import React from 'react';
import PropTypes from 'prop-types';

const BulkCommunicationFilterStateContext = React.createContext(undefined);
const BulkCommunicationFilterDispatchContext = React.createContext(undefined);

function init() {
  return {
    pendingFilters: {},
    appliedFilters: {},
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'setFilter': {
      if (action.value === undefined) {
        // Remove filter marked undefined
        const newState = { ...state };
        delete newState.pendingFilters[action.name];
        delete newState.appliedFilters[action.name];
        return newState;
      }
      return {
        ...state,
        pendingFilters: {
          ...state.pendingFilters,
          [action.name]: action.value,
        },
      };
    }
    case 'removeFilter': {
      const newState = { ...state };
      delete newState.pendingFilters[action.name];
      delete newState.appliedFilters[action.name];
      return newState;
    }
    case 'applyFilters': {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          ...state.pendingFilters,
        },
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function BulkCommunicationFilterProvider({ children, initialState }) {
  const [state, dispatch] = React.useReducer(reducer, initialState, init);

  return (
    <BulkCommunicationFilterStateContext.Provider value={state}>
      <BulkCommunicationFilterDispatchContext.Provider value={dispatch}>
        {children}
      </BulkCommunicationFilterDispatchContext.Provider>
    </BulkCommunicationFilterStateContext.Provider>
  );
}

function useBulkCommunicationFilterStateContext() {
  const context = React.useContext(BulkCommunicationFilterStateContext);

  if (context === undefined) {
    throw new Error('useBulkCommunicationFilterStateContext must be used within a BulkCommunicationFilterProvider');
  }

  return context;
}

function useBulkCommunicationFilterDispatchContext() {
  const context = React.useContext(BulkCommunicationFilterDispatchContext);

  if (context === undefined) {
    throw new Error('useBulkCommunicationFilterDispatchContext must be used within a BulkCommunicationFilterProvider');
  }

  return context;
}

BulkCommunicationFilterProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  initialState: PropTypes.object.isRequired,
};

export {
  BulkCommunicationFilterProvider,
  useBulkCommunicationFilterStateContext,
  useBulkCommunicationFilterDispatchContext,
};
